module.exports = __webpack_public_path__ + "img/banner_left.4a805e98.jpg";